import { render, staticRenderFns } from "./Sucursalesam.vue?vue&type=template&id=43794144"
import script from "./Sucursalesam.vue?vue&type=script&lang=js"
export * from "./Sucursalesam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports